"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILTER_BAR_IDS = exports.FILTER_BAR_SECTION_TYPE = void 0;
var FILTER_BAR_SECTION_TYPE;
(function (FILTER_BAR_SECTION_TYPE) {
    FILTER_BAR_SECTION_TYPE["GENERIC"] = "GENERIC";
    FILTER_BAR_SECTION_TYPE["NO_FILTERS"] = "NO_FILTERS";
})(FILTER_BAR_SECTION_TYPE = exports.FILTER_BAR_SECTION_TYPE || (exports.FILTER_BAR_SECTION_TYPE = {}));
exports.FILTER_BAR_IDS = {
    FLEET_FUEL_ANALYSIS: 'population-outlier-filters',
    DRIVE_SCORE: 'analytics-drive-score-filter-bar',
    FUEL_ECONOMY: 'analytics-fuel-economy',
    SAFETY_PERFORMANCE: {
        SAFETY_EVENTS: 'safety-performance-safety-events-filter-bar',
        SAFETY_METRICS: 'safety-performance-safety-metrics-filter-bar',
    },
    SAFETY_FEATURES: {
        MORE_FILTERS: 'safety-features-more-filter-bar',
        CUSTOM_TAGS: 'safety-features-custom-tags-filter-bar',
    },
    VEHICLE_HISTORY_SAFETY: 'vehicle-history-safety-filter-bar',
    VEHICLE_LIST: 'vehicle-list',
    SUBSCRIPTION_LIST: 'subscription-list',
    FAULTS_LIST: 'faults-list-filter-bar',
    MAINTENANCE_SYSTEM: 'maintenance-system',
    FOTA_CAMPAIGNS: 'fota-campaigns',
    E_VEHICLE_OVERVIEW: 'e-vehicle-overview',
};
